import React from 'react'
import EnhancedModal from '../../../../../../../components/enhanced-modal'
import InfiniteScrollDataTable from '../../../../../../../components/infinite-scroll-data-table'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { getFileMappingWizardFileComponentPreview, hidefileServerPreview } from '../../actions'
import { Button } from 'antd'
import { MODAL_WIDTH_LG } from '../../../../../../../styles/constants'
import { getFilterObjFromViewerObj } from '../../../../../../../utils/filter'
import { translate } from 'react-i18next'


const mapStateToProps = state => ({
    fileServerPath:state.scenes.dataManager.fileMapping.components.wizard.components.addField.fileServerPath,
    fileServerPreviewShow:state.scenes.dataManager.fileMapping.components.wizard.components.addField.fileServerPreviewShow,
    FileComponent:state.scenes.dataManager.fileMapping.components.wizard.components.addField.FileComponent,
    fileCsvRows:state.scenes.dataManager.fileMapping.components.wizard.components.addField.fileCsvRows
})

const mapDispatchToProps = dispatch => ({
    onHidePreviewFile: ()=> dispatch(hidefileServerPreview()),
    onFetchRows: (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, filePath) =>
     dispatch(getFileMappingWizardFileComponentPreview(pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, filePath))
})

const PreviewFileWizard = ({
    t,
    fileServerPreviewShow,
    fileServerPath,
    onHidePreviewFile,
    onFetchRows,
    FileComponent,
    fileCsvRows
}) => {
    return (
        <EnhancedModal
         visible={fileServerPreviewShow}
         onCancel={onHidePreviewFile}
         title={t('scenes.dataManager.fileMapping.wizard.addField.functions.file.preview.title')}
         width={MODAL_WIDTH_LG}
         footer={
            <div>
                <Button onClick={onHidePreviewFile}>{t('scenes.dataManager.fileMapping.wizard.addField.buttons.close')}</Button>
            </div>
         }
        >
         {fileServerPath !== null && 
          <InfiniteScrollDataTable 
            data={fileCsvRows && fileCsvRows.Data}
            rowTotal={fileCsvRows && fileCsvRows.Count}
            cols={fileCsvRows && fileCsvRows.Columns}
            hiddenCols={['NumRow']}
            onChange={({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) =>
            onFetchRows(
                pageNum,
                pageSize,
                getFilterObjFromViewerObj(
                    fileCsvRows && fileCsvRows.Columns.filter(colName => colName !== 'NumRow'),
                    searchText,
                    filters
                ),
                sortCol ? [sortCol] : null,
                sortByDesc,
                FileComponent.separator,
                FileComponent.delimiter,
                FileComponent.hasHeader,
                fileServerPath
                )}
            />}
        </EnhancedModal>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(PreviewFileWizard)